import { defaultizeZoom } from "./defaultizeZoom.js";
export const createZoomLookup = axisDirection => (axes = []) => axes.reduce((acc, v) => {
  // @ts-ignore
  const {
    zoom,
    id: axisId,
    reverse
  } = v;
  const defaultizedZoom = defaultizeZoom(zoom, axisId, axisDirection, reverse);
  if (defaultizedZoom) {
    acc[axisId] = defaultizedZoom;
  }
  return acc;
}, {});